import React, { useEffect, useState } from "react";
import { Outlet, Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import logo from "../../../Assets/Images/logo.png";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { MyMarketLayout } from "./MyMarketLayout";
import MapIcon from "@mui/icons-material/Map";
import MenuItem from "@mui/material/MenuItem";
import Logout from "@mui/icons-material/Logout";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import collapsedLogo from "../../../Assets/Images/shortlogo.png";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { Breadcrumbs, Dialog, DialogContent, Menu, Modal, Typography } from "@mui/material";
import { FilterLayout } from "./FilterLayout";
import Tooltip from "@mui/material/Tooltip";
import { checkImpersonation } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
import Timer from "../../Common/Timer";
import ConstantData from "../../../Utils/Constant";
import { default as MuiLink } from '@mui/material/Link';

const drawerWidth = 235;
var intervalID;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const MiniDrawer = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const getPageLocation = useLocation();
  const showTimer = useSelector(state=>state?.isShowTimer);
  const [enableTimer, setEnableTimer] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [openMyMarket, setOpenMyMarket] = React.useState(false);
  const [hideDropdownIcon, setHideDropdownIcon] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openUserMenu = Boolean(anchorEl);
  const [packInfos,setPackInfos] = React.useState([]);
  const userDetails = useSelector(state => state.userDetails) 
  || JSON.parse(localStorage.getItem("user") || "null");
    const [filter, setFilter] = React.useState({
    showby: null,
    filterBy: [],
  });
  const { userid } = useParams();
  const mapParkData = useSelector((state) => state.mapParkData);
  
    useEffect(() => { 
          fetchData();
    }, [showTimer]);
   
    
    
   async function fetchData() {
        const cache = await caches.open('timer-cache');
        const response = await cache.match('timerState');
        if (response) {
          setEnableTimer(true);
        }else{
          dispatch({ type: "isShowTimer", value: false });
        }
    }

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = (value) => {
    setHideDropdownIcon(!hideDropdownIcon);
    setOpen(!value);
    setOpenMyMarket(false);
  };

  useEffect(() => {}, [mapParkData]);

  const navigate = useNavigate();

  const handleClick = () => {
    dispatch({ type: 'developmentFilters', value: [] });
    setOpenMyMarket(true);
    navigate("/my-market");
  };

  const handleLogout = () => {
    apiCommonTrigger("get", Config.API_URL + "/AuthToken/logout").then(res => {
      localStorage.clear();
      dispatch({ type: 'RESET_APP_STATE' });
      navigate("/");
    })
  };

  const returnAdmin = (loc) => {
    if(loc === "returnToAdminDirectLink" || loc === "returnTouser"){
      loc === "returnTouser" ? navigate("/admin/user-account/"+userid) : navigate("/admin/user-management");
      return;
    }
    apiCommonTrigger("get" , Config.API_URL + "/admin/impersonate/logout")
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem("accessKey", res.data.token);
          const userType = res.data.usertype;
          localStorage.setItem("user", JSON.stringify(res.data));

          if (userType == "Administrator") {
            localStorage.setItem("isAdmin", true);
            localStorage.removeItem("impersonated");
            setOpenMyMarket(false);
            navigate("/admin/user-management");
          }
          // navigate("/admin/user-management");
        }
      })
      .catch((error) => {
        handlingCatchError(error, navigate);
      });
  };

  const getMarketCredit = (packInfo) => {
    if(localStorage.getItem('impersonated') === 'true') {
      checkImpersonation();
    }else{
      let inputData={ lookupkey: packInfo.lookupkey}
       apiCommonTrigger("post",`${Config.API_URL}/subscription/buymarketcredit`,inputData)
      .then((res) => {
        if (res.status === 200) {
          window.open(res.headers.location, "_self");
        }
        if (
          localStorage.getItem("opened") === true ||
          localStorage.getItem("opened") === "true"
        ) {
          document.getElementById("hit-avail-count").click();
        } else {
          startInterval();
          handlingCatchError(res, navigate);
        }
      })
      .catch((error) => {
        handlingCatchError(error, navigate);
      });
    }
  };

  //call API evey 3sec
  const startInterval = () => {
    intervalID = setInterval(() => checkAvailableCount(), 50000);
  };
  useEffect(() => {
    if (props && props.packageProps && props.packageProps.packageFullData.length > 0) {
      setPackInfos([props.packageProps.packageFullData.filter(data=>data.id === ConstantData.lookupKeyMap.fiveReport)[0], props.packageProps.packageFullData.filter(data=>data.id === ConstantData.lookupKeyMap.tenReport)[0]])
    }
  }, [props.packageProps])

  //stop the api calling interval
  const stopInterval = () => {
    clearInterval(intervalID);
  };

  async function checkAvailableCount() {
    await apiCommonTrigger("get", Config.API_URL + "/account/useravailability")
      .then((res) => {
        if (res.status === 200) {
          if (res.data.availableCount >= 1) {
            stopInterval();
          }
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((error) => {
        handlingCatchError(error, navigate);
      });
  }

  var username =
    userDetails !== null && userDetails.username !== null
      ? userDetails.username
      : "";

  const getDataFromChild = async (
    showby,
    filterBy,
    isActive = false,
    isChecked = null
  ) => {
    const filterOptions = {
      ...filter,
      showby: showby.toString(),
      filterBy: filterBy,
    };

    const returndata = {
      filterOptionsData: filterOptions,
      bool: isActive && !isChecked ? true : false,
    };

    dispatch({ type: "filterOptions", value: returndata });
    setFilter(filterOptions);

    return true;
  };


  const isDemoMarket = ()=>["/sample-market"]?.includes(getPageLocation?.pathname);
  const isImpersonated = (localStorage.getItem("impersonated") === 'true');


  const extendClassName = getPageLocation && getPageLocation.pathname !== "/market-search" && !isDemoMarket() ? " extend-scroll" : "";

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      
      <AppBar
        position="fixed"
        open={open}
        className={
          open ? "header-opened top-header" : "header-closed top-header"
        }
      >
        {localStorage.getItem("impersonated") === 'true' && ( 
          <div className="sticky-header"> <h6 className="text-center"><AccountCircleIcon />{`You are logged in as "${username}".`} <span className="return-admin" onClick={() => returnAdmin()}>Return to Admin</span></h6></div>
        )}
        <Toolbar>
        
          <div className="inline-block-menu">

            <IconButton
              color="inherit"
              aria-label="open"
              onClick={() => handleDrawerOpen(open)}
              edge="start"
              className="menu-resizer"
              sx={{
                marginRight: 5,
                // ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className="user-profile">
            <span className="welcome-user">
              Welcome <b>{username}</b>
            </span>
            <IconButton onClick={handleOpen} className="ps-0 welcome-btn">
              <AccountCircleIcon />
              <ArrowDropDownIcon />
            </IconButton>
          </div>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={openUserMenu}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            className="top-logout"
          >
            {localStorage.getItem("impersonated") === "true" ? (
              <MenuItem onClick={() => returnAdmin()} className="menu-return-admin">
                <ListItemIcon>
                  <AccountCircleIcon fontSize="small" />
                </ListItemIcon>
                Return to Admin
              </MenuItem>
            ) : (
              <MenuItem onClick={() => handleLogout()}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            )}
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        open={open}
        className={
          open ? "left-opened left-side-bar" : "left-closed left-side-bar"
        }
      >
        <img
          src={open ? logo : collapsedLogo}
          alt="RVParkIQ"
          className="rvparks-logo"
        />
        {localStorage.getItem("impersonated") && localStorage.getItem("impersonated") === "true" ? '' :
        <Link to="/my-account" state="" className={
            getPageLocation.pathname === "/my-account"
              ? "navigation-link active"
              : "navigation-link"
          }>
          <ListItem
            button
            className="navigation-list"
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              className="list-item-icon"
              sx={{
                minWidth: 0,
                mr: open ? 3 : "auto",
                justifyContent: "center",
              }}
            >
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText
              className="list-item-text"
              inset
              primary="My Account"
              sx={{ opacity: open ? 1 : 0 }}
            />
          </ListItem>
        </Link>}

        {userDetails &&
          userDetails.usertype ===
            "Administrator" && (
            <Link
              to="/admin/user-management"
              state=""
              className={
            getPageLocation.pathname === "/admin/user-management"
              ? "navigation-link active"
              : "navigation-link"
          }
            >
              <ListItem
                button
                className="navigation-list"
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className="list-item-icon"
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText
                  className="list-item-text"
                  inset
                  primary="Admin"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </Link>
          )}

        <Link to="/market-search" state="" onClick={()=> {
          dispatch({ type: 'developmentFilters', value: [] });
        }} className={
            getPageLocation.pathname === "/market-search"
              ? "navigation-link active"
              : "navigation-link"
          }>
          <ListItem
            button
            className="navigation-list"
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              className="list-item-icon"
              sx={{
                minWidth: 0,
                mr: open ? 3 : "auto",
                justifyContent: "center",
              }}
            >
              <MapIcon />
            </ListItemIcon>
            <ListItemText
              className="list-item-text"
              inset
              primary="Market Search"
              sx={{ opacity: open ? 1 : 0 }}
            />
          </ListItem>
        </Link>
        <Link
          to="/fav-location"
          state={{ prevPath: location.pathname }}
          className={
            getPageLocation.pathname === "/fav-location"
              ? "navigation-link active"
              : "navigation-link"
          }
        >
          <ListItem
            button
            className="navigation-list"
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <Tooltip
              title="View and open previously saved locations"
              arrow
              placement="right"
              PopperProps={{ disableInteractive: true }}
            >
              <div className="hover-tooltip-ele">
                <ListItemIcon
                  className="list-item-icon"
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <StarBorderIcon />
                </ListItemIcon>
                <ListItemText
                  className="list-item-text"
                  inset
                  primary="Favorite Locations"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </div>
            </Tooltip>
          </ListItem>
        </Link>
        <Link
          to="/saved-search"
          state={{ prevPath: location.pathname }}
          className={
            getPageLocation.pathname === "/saved-search"
              ? "navigation-link active"
              : "navigation-link"
          }
        >
          <ListItem
            button
            className="navigation-list"
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <Tooltip
              title="View and open previously saved filters on the market search map"
              arrow
              placement="right"
              PopperProps={{ disableInteractive: true }}
            >
              <div className="hover-tooltip-ele">
                <ListItemIcon
                  className="list-item-icon"
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <BookmarkBorderOutlinedIcon />
                </ListItemIcon>
                <ListItemText
                  className="list-item-text"
                  inset
                  primary="Saved Searches"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </div>
            </Tooltip>
          </ListItem>
        </Link>
        <div className={
            getPageLocation.pathname === "/my-market"
              ? "navigation-link active"
              : "navigation-link"
          }>
          <ListItem
            button
            className="navigation-list my-markets-menu"
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              className="list-item-icon"
              sx={{
                minWidth: 0,
                mr: open ? 3 : "auto",
                justifyContent: "center",
              }}
              onClick={handleClick}
            >
              <ShoppingBagOutlinedIcon />
            </ListItemIcon>
            <ListItemText
              className="list-item-text"
              onClick={handleClick}
              inset
              primary="My Markets"
              sx={{ opacity: open ? 1 : 0 }}
            />
            <span
              style={{ visibility: hideDropdownIcon ? "hidden" : "" }}
              className="expandmarket-icon"
            >
              {openMyMarket ? (
                <ExpandLess onClick={() => setOpenMyMarket(!openMyMarket)} />
              ) : (
                <ExpandMore onClick={() => setOpenMyMarket(!openMyMarket)} />
              )}
            </span>
          </ListItem>
        </div>
        {openMyMarket ? (
          <div className={"mymarkets-submenu" + extendClassName}>
            <MyMarketLayout openMyMarket={openMyMarket} />
          </div>
        ) : null}
        <Divider />
        {packInfos.length>0 &&
        packInfos.map((packInfo)=>userDetails &&
        (userDetails.usertype === "Free" ||
          userDetails.usertype === "Basic") ? (
          <>
            <div
                className={`navigation-link buy-bundle-btn ${packInfo.units === 10 ? 'orange-btn' : ""}`}
              onClick={() => getMarketCredit(packInfo)}
            >
              <ListItem
                // button
                className="navigation-list"
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className="list-item-icon"
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <ShoppingCartOutlinedIcon />
                </ListItemIcon>
                <ListItemText
                  className="list-item-text"
                  inset
                  primary={
                    packInfo &&
                    "Buy "+packInfo.units+" Markets @ " + packInfo.currency + packInfo.price
                  }
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </div>
            <Divider />
          </>
        ) : (
          ""
        ))}
        {getPageLocation && (getPageLocation.pathname === "/market-search" || isDemoMarket() )? (
          <>
            <div className={`navigation-link no-background ${isDemoMarket()  ? "blur-sample-market":""}`}>
           
              <ListItem
                className="navigation-list"
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  className="list-item-icon"
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <FilterAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText
                  className="list-item-text"
                  inset
                  primary="Filter"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
            </div>
            <div className={`mymarkets-submenu filter-by-submenu ${isDemoMarket()  ? "blur-sample-market":""}`}
            style={{overflow : isDemoMarket()?"hidden":""}}
            ><FilterLayout demoMarket={isDemoMarket()} fetchDataFromChild={getDataFromChild} /></div>
            <Divider />
          </>
        ) : (
          ""
        )}
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3 }}
        className={isImpersonated? "right-side-section admin-view-map-section" :  "right-side-section"}
      >
        {enableTimer ? <Timer /> : null}
        {getPageLocation &&
        (getPageLocation.pathname.includes("/admin/user-account") ||
          getPageLocation.pathname.includes("/admin/user-subscription")) ? (
            <Breadcrumbs className="mt-2 ms-1" aria-label="breadcrumb">
            <MuiLink
              underline="always"
              color={"#38a83c"}
              onClick={(e) => {
                e.preventDefault();
                returnAdmin(
                  getPageLocation.pathname.includes("/admin/user-subscription")
                    ? "returnTouser"
                    : "returnToAdminDirectLink"
                );
              }}
            >
              {getPageLocation.pathname.includes("/admin/user-subscription")
                ? "User"
                : "Admin"}
            </MuiLink>

            <Typography sx={{ color: "text.primary" }}>User Details</Typography>
          </Breadcrumbs>
        ) : null}

       
        <Outlet />
      </Box>
    </Box>
  );
};

function LoggedInLayout(props) {
  return (
    <React.Fragment>
      <MiniDrawer packageProps={props} />
    </React.Fragment>
  );
}

export default LoggedInLayout;
